export default {
  pageTitle: 'Scheduling',
  blocks: 'Blocks',
  blockId: 'Block ID',
  searchPlaceholder: 'Search block, vendor, vehicle or driver',
  tabs: {
    blocks: 'Blocks',
    drivers: 'Drivers',
    vehicles: 'Vehicles',
  },
  columns: {
    block: 'Block',
    serviceProvider: 'Service Provider',
    driver: 'Driver',
    vehicle: 'Vehicle',
  },
  tooltip: {
    routeDay: 'Trip day',
    departureLocation: 'Departure Location',
    plannedActDpt: 'Planned/Act. Dpt.',
    arrivalLocation: 'Arrival Location',
    plannedActArr: 'Planned/Act. Arr.',
    days: 'Days',
    status: 'Status',
    delayTime: 'Delay time',
    reservations: 'Reservations',
    blockId: 'Block ID',
    startingTime: 'Starting Time',
    endingTime: 'Ending Time',
    totalWorkingTime: 'Total Working Time',
    totalAssignments: 'Total Assignments',
    reservationCount: 'Planned Rider Count',
  },
  status: {
    CREATED: 'Not Started',
    STARTED: 'Started',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    ACTIVE_ON_TIME: 'On Time',
    ACTIVE_DELAYED: 'Delayed',
    CANCELED_NO_RESERVATION: 'Canceled (No Reservation)',
    CANCELED_BY_ADMIN: 'Canceled by Admin',
  },
  legend: {
    inbound: 'Inbound',
    outbound: 'Outbound',
    loop: 'Loop',
    activeOnTime: 'On Time',
    activeDelayed: 'Delayed',
    completed: 'Completed',
    canceledNoReservation: 'Canceled due to no reservation',
    canceledByAdmin: 'Canceled by admin',
    numberOfReservations: 'Number of reservations',
  },
  alertBar: {
    message:
      "To make changes for a single date, edit the resources for the blocks you want and click Apply once you're happy with the final schedule.",
    message2:
      'To apply the changes to a date range, update just one block, click Apply, and select the dates and days for which the change will apply.',
    revertChanges: 'Cancel Changes',
    apply: 'Apply',
  },
  multiBlockConfirm: {
    title: 'Confirm Changes',
    message: "Please confirm that you'd like to change the schedules of the edited blocks.",
    change: 'Change',
    cancel: 'Cancel',
  },
  singleBlockEdit: {
    title: 'Edit Assignments',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    on: 'on',
    betweenDates: 'between dates',
    permanently: 'permanently',
    start: 'Start',
    end: 'End',
    startDate: 'Start Date',
    endDate: 'End Date',
    days: 'Days',
    changeDriverDesc: "Please confirm that you'd like to change the driver of {blockId} from {from} to {to}.",
    changeVehicleDesc: "Please confirm that you'd like to change the vehicle of {blockId} from {from} to {to}.",
    confirmChanges: "Please confirm that you'd like to change the assignments for {blockId}.",
  },
  assignmentConflict: 'Assignment Conflict',
  assignmentConflictMessage: 'We found a conflict in the assignments of some blocks. Please review them and try again.',
  bulkAssignmentConflictMessage:
    'We found a conflict in the assignments of blocks {blockIds}. Please review these blocks and try again.',
  newBlock: {
    buttonLabel: 'New Block',
    title: 'Create New Block',
    blockIdLabel: 'Block ID',
    blockIdPlaceholder: 'Enter block ID',
    displayNameLabel: 'Display Name',
    displayNamePlaceholder: 'Enter display name',
    successMessage: 'Block created successfully',
    addedSuccessfully: 'Block added successfully',
    addedSuccessfullyLong:
      'Block created successfully. Please assign a trip on the Trips or Dispatch page to view it here',
    errorMessage: 'Failed to create block',
    duplicateBlockId: 'A block with this Block ID already exists. Block ID must be unique.',
  },
  editBlock: {
    title: 'Edit Block',
    updatedSuccessfully: 'Block updated successfully',
    errorMessage: 'Failed to update block',
  },
  deleteBlock: {
    confirmTitle: 'Delete Block',
    confirmText: 'Are you sure you want to delete this block?',
    confirmWithAssignmentsText:
      'There are trips assigned to this block. Please review the assigned trips before proceeding with deletion.',
    confirmButton: 'Delete',
    cancelButton: 'Cancel',
    successMessage: 'Block deleted successfully',
    errorMessage: 'Failed to delete block',
  },
};
